import { ComponentInfoVo } from './component-info-co-vo';

export class EmploymentPlanCorVo {
    constructor(

        public id?: number,

        public clientName?: string,

        public clientSSN?: string,

        public provider?: string,

        public providerCounty?: string,

        public empPlanStartDt?: any,

        public estimatedCompletionDt?: any,

        public clientAgreementDt?: any,

        public shortTermGoalCd?: string,

        public longTermGoalCd?: string,

        public notes?: string,

        public componentInfoVos?: ComponentInfoVo[],

        public personId?: number
        ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/employment-plan-co-vo.ts